import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionItem, List } from '@sm/wds-react';
import { t } from '@sm/intl';

import SMHeaderContext from '../../../SMHeaderContext';
import { SubMenuItem } from '../components/SubMenuItem';
import NavBarCopy from '../../../copy/NavBarCopy';
import getMyTeamMenuItems from '../../../../../helpers/TeamMenuHelpers';

export const MyTeamMenu = ({ user }) => {
  const { user: session } = useContext(SMHeaderContext);

  const nameKey = 'My Team';
  const menuItems = getMyTeamMenuItems({ user, session });
  const title = t(NavBarCopy.MY_TEAM);

  return (
    <Accordion
      key={`accordion-${nameKey}`}
      className="mobile-menu--li-accordionitem"
    >
      <AccordionItem title={title}>
        <List transparent>
          {menuItems.map(item => {
            return <SubMenuItem {...item} />;
          })}
        </List>
      </AccordionItem>
    </Accordion>
  );
};

MyTeamMenu.propTypes = {
  user: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default MyTeamMenu;
